import React, { useState } from 'react';
import { Button } from './ui/button';
import { Mail, Phone, MapPin } from 'lucide-react';

const BookAppointment = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    datetime: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/mail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          subject: `Appointment Booking from ${formData.name}`,
          ...formData
        })
      });
      const result = await response.json();
      if (result.status === 'success') {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', datetime: '', message: '' });
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <section id="book-appointment" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Left Side - Contact Us */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-4xl font-serif italic mb-8">Contact Us</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-black mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                  <a href="mailto:jokerandquinnsalon@gmail.com" className="text-gray-600 hover:text-black">
                    jokerandquinnsalon@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-black mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Phone</h3>
                  <a href="tel:+917358722299" className="text-gray-600 hover:text-black block">
                    +91 7358722299
                  </a>
                  <a href="tel:+919884022956" className="text-gray-600 hover:text-black block">
                    +91 9884022956
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-black mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Address</h3>
                  <p className="text-gray-600">
                    Joker & Quinn Unisex Luxury Salon,<br />
                    #18/70, Halls Road, Kilpauk,<br />
                    Chennai – 600 010
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Book Appointment Form */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-4xl font-serif italic mb-8">Book Appointment</h2>
            
            <form onSubmit={handleSubmit}>
              {submitted && (
                <div className="mb-4 p-3 bg-green-100 text-green-800 rounded-lg">
                  Appointment booked successfully! We'll contact you soon.
                </div>
              )}
              {error && (
                <div className="mb-4 p-3 bg-red-100 text-red-800 rounded-lg">{error}</div>
              )}
              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-semibold mb-2">Date and Time</label>
                <input
                  type="datetime-local"
                  name="datetime"
                  value={formData.datetime}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
                />
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-semibold mb-2">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
                ></textarea>
              </div>

              <Button
                type="submit"
                className="w-full bg-black hover:bg-gray-800 text-white py-3 rounded-lg text-lg"
              >
                Book Appointment
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookAppointment;
